/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState, useRef } from "react";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import { useTranslation } from "react-i18next";
import Car from "../../components/car";
import Breadcrumb from "../../components/__simple/breadcrumb";
import { useDispatch } from "react-redux";
import { changeIcons } from "../../_redux/slices/navSlice";
import axios from "axios";
import { InputField } from "../../components/_input/_input";
import { DropDownInput } from "../../components/_input/_dropdown";
import config from "../../configuration/config";
import { Helmet } from "react-helmet";
import TestEparts from "../parts/testEparts";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { EmptyState } from "../../components/EmptyState";
import { useTrackViewCarList } from "../../hooks/useTrackOfferPromotion";
import { OfferSections } from "../../sections/offersSection";
import InfoCircle from "../../components/__simple/_infoCirclejsx";
import Info from "../../components/_info";
import { groupBy, mapValues, omit } from "lodash";
import ImageGallery from "react-image-gallery";

SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export function VehicleOnlinePage() {
  const { t: trans, i18n } = useTranslation(["inputs", "heading", "vehicales", "info", "common"]);
  const [vehicles, setVehicles] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [isLoadingVehicles, setLoadingVehicles] = useState(true);
  const [brands, setBrands] = useState([]);
  const [offerVehicle, setOfferVehicle] = useState([]);
  const [Featured, setFeatured] = useState([]);
  const [cachSNImages, setCachSNImages] = useState({});
  // Real images grouped by ProductID — the card's serial often isn't the one
  // that has photos, but any serial of the same product is a valid match.
  const [cachByProduct, setCachByProduct] = useState({});
  const [gallery, setGallery] = useState([]);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const popRef = useRef(null);
  const [isDarkMode, setIsDarkMode] = useState(document.body.classList.contains("dark"));

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.body.classList.contains("dark"));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const dispatch = useDispatch();
  const [carFilter, setCarFilter] = useState(null);
  let lang = i18n.language || "ar";
  const languageDir = "language-" + lang;
  const [searchValue, setSearchValue] = useState(null);
  const [activeOutColor, setActiveOutColor] = useState("");
  const [valueRing, setValueRing] = useState({
    start: 40000,
    end: 750000,
  });

  const [sections] = useState([
    { GUID: "6a37a931-2a75-4b45-9073-2164123b7d08", catId: 1, NameAr: "سيدان", NameEn: "SEDAN" },
    { GUID: "c4341689-4bc5-44c5-b948-2546aee65b92", catId: 5, NameAr: "كوبيه", NameEn: "COUPES" },
    { GUID: "871e103b-9194-449a-a91c-9e4ef39ab805", catId: 4, NameAr: "متعددة الاستخدامات", NameEn: "SUV" },
    { GUID: "7e9e1e76-4149-4781-b8c0-03c9c1159b6f", catId: 2, NameAr: "عائلية", NameEn: "MVP" },
    { GUID: "0c1f4216-7320-4304-b316-b9de74c5a24b", catId: 3, NameAr: "مركبات تجارية", NameEn: "COMMERCIAL" },
  ]);

  const [checkedCateegores, setCheckedCateegores] = useState([]);

  const callback = useCallback(async () => {
    setLoadingVehicles(true);
    try {
      const res = await axios.request({
        baseURL: config.controllURL,
        url: lang + "/api/vehicles/OnlineVehicles",
        method: "get",
      });

      setVehicles(res.data.vehicles);
      setBrands(res.data.brands);

      const homeExtraRes = await axios.request({
        baseURL: config.controllURL,
        url: lang + "/api/home/HomeExtra",
        method: "get",
      });
      setOfferVehicle(homeExtraRes.data.offerVehicle);

      const snImagesResponse = await axios.post(`${config.controllURL}${lang}/api/Pages/siteFetchCarSNImages`, {
        SN: null,
      });
      if (snImagesResponse.status === 200) {
        const sortedData = [...snImagesResponse.data].sort((a, b) => {
          const numA = parseFloat(a.Attachment_Comments), numB = parseFloat(b.Attachment_Comments);
          return (isNaN(numA) || isNaN(numB)) ? String(a.Attachment_Comments || "").localeCompare(String(b.Attachment_Comments || "")) : numA - numB;
        });
        const gList = sortedData.map(item => ({
          ...item,
          original: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
          thumbnail: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
          fullscreen: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
          originalHeight: "50", originalWidth: "50", sizes: "50"
        }));
        const groupResult = mapValues(groupBy(gList, "SN"), (fList) => fList.map((items) => omit(items, "SN")));
        setCachSNImages(groupResult);
        setCachByProduct(mapValues(groupBy(gList.filter((x) => x.ProductID), "ProductID"), (fl) => {
          // Same product can have several in-stock serials sharing the SAME photos;
          // dedupe by image URL so the gallery doesn't repeat them.
          const seen = new Set();
          return fl.filter((it) => { if (seen.has(it.Image)) return false; seen.add(it.Image); return true; }).map((it) => omit(it, ["SN", "ProductID"]));
        }));
      }

      setLoadingVehicles(false);
    } catch (error) {
      console.log(error);
      setLoadingVehicles(false);
    }
    const RequsetFeatured = async () => {
      try {
        const response = await axios.post(`${config.controllURL}${lang}/api/Pages/DetailsSiteVehicleSpecial`, {
          ObjectSettings: { MetaData: false },
        });
        setFeatured(response.data.ApiObjectData);
      } catch (error) {
        console.log(error);
      }
    };
    RequsetFeatured();
  }, [lang]);

  const FetchCarSNImages = async (SN) => {
    if (cachSNImages[SN]) {
      setGallery(cachSNImages[SN]);
      if (popRef.current && cachSNImages[SN]?.length > 0) {
        popRef.current.toggleFullScreen();
      }
      return;
    }
    try {
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/siteFetchCarSNImages`, {
        SN: SN,
      });
      if (response.status === 200) {
        const sortedData = [...response.data].sort((a, b) => {
          const numA = parseFloat(a.Attachment_Comments), numB = parseFloat(b.Attachment_Comments);
          return (isNaN(numA) || isNaN(numB)) ? String(a.Attachment_Comments || "").localeCompare(String(b.Attachment_Comments || "")) : numA - numB;
        });
        const filterG = sortedData.map(item => ({
          ...item,
          original: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
          thumbnail: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
          fullscreen: (config.FilePathURL || config.mainURL).replace(/\/$/, "") + item.Image,
          originalHeight: "50", originalWidth: "50", sizes: "50"
        }));
        setGallery(filterG);
        setCachSNImages(prev => ({ ...prev, [SN]: filterG }));
        if (popRef.current && filterG?.length > 0) {
          popRef.current.toggleFullScreen();
        }
      }
    } catch (e) { console.error(e); }
  };

  // Open the gallery for a model: prefer the product's real images, fall back
  // to the card serial's own images. (The card serial usually has no photos.)
  const openProductGallery = (productID, sn) => {
    const imgs = cachByProduct[productID] || cachSNImages[sn];
    if (!imgs || imgs.length === 0) return;
    setGallery(imgs);
    if (popRef.current) popRef.current.toggleFullScreen();
  };

  useEffect(() => {
    callback();
  }, [callback]);

  const OnCheckCate = (event) => {
    const { id, checked } = event;
    const listValues = checked
      ? [...checkedCateegores, id]
      : checkedCateegores.filter((brandId) => brandId !== id);

    setCheckedCateegores(listValues);
    filterCars(carFilter, listValues);
  };

  const filterCars = (brand, thisCheckedCateegores = checkedCateegores) => {
    setCarFilter(brand);
    setLoadingVehicles(true);

    let filterData = brand != null ? vehicles.filter((car) => car.brand === brand) : vehicles;

    if (thisCheckedCateegores && thisCheckedCateegores.length > 0) {
      filterData = filterData.filter((car) => thisCheckedCateegores.includes(car.carCategories));
    }

    if (valueRing.start > 40000 || valueRing.end < 750000) {
      filterData = filterData.filter((car) => parseFloat(car.minPrice) >= valueRing.start && parseFloat(car.minPrice) <= valueRing.end);
    }

    if (searchValue != null && searchValue !== "") {
      filterData = filterData.filter((car) => (car.descriptionEn.toLowerCase() + " " + car.year).includes(searchValue.toLowerCase()));
    }

    let uniquetypes = Object.values(
      filterData.reduce((acc, vehicle) => {
        const colorObj = { image: vehicle.siteOutColorImage, name: vehicle.colorName, colorID: vehicle.colorID };
        const key = `${vehicle.type}_${vehicle.year}`;
        if (!acc[key]) {
          acc[key] = { ...vehicle, listTypeColors: [colorObj] };
        } else {
          const exists = acc[key].listTypeColors.some((c) => c.image === vehicle.siteOutColorImage && c.name === vehicle.colorName);
          if (!exists) acc[key].listTypeColors.push(colorObj);
        }
        return acc;
      }, {}),
    );

    if (activeOutColor) {
      uniquetypes = uniquetypes.filter((vehicle) => vehicle?.listTypeColors?.some((c) => c.colorID === activeOutColor));
    }

    setFilteredVehicles(uniquetypes.sort((a, b) => parseFloat(a.minPrice) - parseFloat(b.minPrice)));
    setLoadingVehicles(false);
  };

  useEffect(() => {
    filterCars(carFilter);
  }, [valueRing, activeOutColor, vehicles]);

  useEffect(() => {
    dispatch(changeIcons({ iconsBlack: true }));
    return () => { dispatch(changeIcons({ iconsBlack: false })); };
  }, [dispatch]);

  const currentListName = searchValue
    ? `Search Results - ${searchValue}`
    : carFilter ? `Vehicle Online List - ${carFilter}` : "Vehicle Online List - All Cars";

  useTrackViewCarList({
    listId: "vehicle_online_list",
    listName: currentListName,
    cars: filteredVehicles,
    currency: "SAR",
  });

  const [seoPageInfo, setSeoPageInfo] = useState({});
  useEffect(async () => {
    try {
      const response = await axios.post(`${config.controllURL}${lang}/api/Pages/SiteFetchSeoPages`, {
        page: "Online Cars Store",
      });
      if (response.status === 200) setSeoPageInfo(response.data[0]);
    } catch (e) { console.error(e); }
  }, []);

  return (
    <div className={`vehicle-page ${languageDir}`}>
      <Helmet>
        <meta charSet="utf-8" />
        {seoPageInfo?.title && <title>{seoPageInfo?.title}</title>}
        {seoPageInfo?.MetaDescription && <meta name="description" content={seoPageInfo?.MetaDescription} />}
      </Helmet>

      <div className="container py-10 flex items-center justify-between">
        <Breadcrumb links={[{ name: trans("info:Online_Cars_Store") }]} />
        <div className="bg-g-light text-g px-4 py-1 rounded-full text-12 font-black uppercase">
          {lang === "ar" ? "إصدار تجريبي" : "BETA"}
        </div>
      </div>

      <div className="container pb-20">
        <div className="flex flex-col md:flex-row gap-10">
          {/* Sidebar */}
          <div className="w-full md:w-1/4">
            <div className="vehicle-sidebar">
              <div className="sidebar-section">
                <h4 className="flex items-center gap-2 text-gray-900 dark:text-white"><img src="/assets/icons/search.svg" className="w-4 h-4 dark:brightness-0 dark:invert" alt="search" /> {trans("info:search")}</h4>
                <InputField
                  searchIcon={true}
                  placeholder={trans("info:search")}
                  onChangeValue={(e) => setSearchValue(e.target.value?.trim())}
                  onClicksearchIcon={(value) => filterCars(carFilter)}
                  value={searchValue}
                  extraClasses="dark:bg-[#20222a] dark:text-white dark:border-white/10"
                />
              </div>

              <div className="sidebar-section">
                <h4 className="text-gray-900 dark:text-white"><i className="fa fa-money"></i> {trans("info:price")}</h4>
                <TestEparts
                  minProp={40000}
                  maxProp={750000}
                  minDistanceProp={10000}
                  defaultValueProp={[40000, 750000]}
                  returnProp={(value) => setValueRing(value)}
                />
              </div>

              <div className="sidebar-section">
                <h4 className="text-gray-900 dark:text-white text-[13px] font-[700] mb-3 flex items-center gap-2"><i className="fa fa-list"></i> {trans("new:categories")}</h4>
                <div className="flex flex-col gap-3">
                  {sections.map((B) => (
                    <label key={B.catId} className="flex items-center gap-3 cursor-pointer group">
                      <div className="flex items-center justify-center shrink-0 w-5 h-5">
                        <input
                          type="checkbox"
                          id={B.catId}
                          name={"CH_SEC" + B.catId}
                          onChange={(e) => OnCheckCate(e.target)}
                          className="w-5 h-5 text-[#18a94e] accent-[#18a94e] cursor-pointer"
                          style={{
                            appearance: 'auto',
                            WebkitAppearance: 'checkbox',
                            minWidth: '18px',
                            minHeight: '18px',
                            width: '18px',
                            height: '18px',
                            padding: 0,
                            margin: 0,
                            outline: 'none',
                            border: 'none',
                            boxShadow: 'none'
                          }}
                        />
                      </div>
                      <span className="text-[14px] font-[600] text-[#444] dark:text-[#8a8f99] group-hover:text-[#111] dark:group-hover:text-white transition-colors">
                        {lang === "en" ? B.NameEn : B.NameAr}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="sidebar-section">
                <h4 className="text-gray-900 dark:text-white"><i className="fa fa-paint-brush"></i> {trans("form:color")}</h4>
                <DropDownInput
                  title={trans("form:color")}
                  options={vehicles
                    .filter((color, index, self) => index === self.findIndex((c) => c.colorID === color.colorID) && color.siteOutColorImage != null)
                    .map((color) => ({
                      value: color.colorID,
                      text: lang === 'ar' ? color.colorNameAr : color.colorNameEn,
                    }))}
                  onSelect={(color) => setActiveOutColor(color)}
                  selectedValue={activeOutColor}
                />
              </div>

              <div className="sidebar-section">
                <button
                  onClick={() => {
                    setSearchValue("");
                    setCarFilter(null);
                    setCheckedCateegores([]);
                    setActiveOutColor("");
                    setValueRing({ start: 40000, end: 750000 });
                  }}
                  className="w-full py-4 text-g dark:text-g-light font-black text-14 border-2 border-g dark:border-g/50 border-dashed rounded-xl hover:bg-g-light dark:hover:bg-g/10 transition-all"
                >
                  {trans("info:clear-all-filters")}
                </button>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="w-full md:w-3/4">
            <div className="vehicle-filter-group start mb-10 flex flex-wrap gap-4">
              <button
                onClick={() => filterCars(null)}
                className={`px-8 py-3 rounded-xl font-bold transition-all ${carFilter == null ? 'bg-g text-white shadow-[0_4px_14px_rgba(24,169,78,0.2)] dark:shadow-none' : 'bg-white dark:bg-[#1a1c23] border border-black/5 dark:border-white/5 text-gray-900 dark:text-white hover:border-g hover:text-g'}`}
              >
                {trans("inputs:all")}
              </button>
              {brands.map((brand, index) => (
                <button
                  key={index}
                  onClick={() => filterCars(brand.name)}
                  className={`px-8 py-3 rounded-xl font-bold transition-all ${carFilter == brand.name ? 'bg-g text-white shadow-[0_4px_14px_rgba(24,169,78,0.2)] dark:shadow-none' : 'bg-white dark:bg-[#1a1c23] border border-black/5 dark:border-white/5 text-gray-900 dark:text-white hover:border-g hover:text-g'}`}
                >
                  {brand.name}
                </button>
              ))}
            </div>

            {isLoadingVehicles ? (
              <div className="vgrid">
                <SkeletonTheme baseColor={isDarkMode ? "#20222a" : "#ebebeb"} highlightColor={isDarkMode ? "#2c2f3a" : "#f5f5f5"}>
                  {[1, 2, 3, 4, 5, 6].map((i) => (
                    <div key={i} className="bg-white dark:bg-[#1a1c23] rounded-[2rem] p-6 shadow-sm border border-gray-100 dark:border-white/5">
                      <Skeleton height={200} borderRadius={"1.5rem"} className="mb-6" />
                      <Skeleton width="70%" height={24} className="mb-4" />
                      <Skeleton width="40%" height={20} className="mb-6" />
                      <div className="flex justify-between items-center">
                        <Skeleton width="30%" height={20} />
                        <Skeleton width="40%" height={40} borderRadius={12} />
                      </div>
                    </div>
                  ))}
                </SkeletonTheme>
              </div>
            ) : filteredVehicles?.length > 0 ? (
              <div className="vgrid">
                {filteredVehicles?.map((vehicle, index) => (
                  <Car
                    key={vehicle?.productTarget + "_" + vehicle?.colorID + "_" + index}
                    year={vehicle.year}
                    img={vehicle.image}
                    name={lang == "ar" ? (vehicle.brandAr + " " + vehicle.groupAr + " " + (vehicle.shortDescriptionAr?.replace(vehicle?.brandAr, "") || "") + " " + vehicle.year) : (vehicle.brandEn + " " + vehicle.groupEn + " " + (vehicle.shortDescriptionEn?.replace(vehicle?.brandEn, "") || "") + " " + vehicle.year)}
                    brand={vehicle.brand}
                    group={vehicle.group}
                    minPrice={vehicle.minPrice}
                    link={"/" + lang + "/car/Overview/" + vehicle?.sn + "/" + vehicle.productTarget}
                    ProductId={vehicle.productID}
                    id={vehicle.productTarget}
                    buyOnline={vehicle.buyOnline}
                    showPric={true}
                    goBuyDerict={true}
                    carData={vehicle}
                    listcolors={vehicle.listTypeColors}
                    newCar={vehicle.newCar}
                    hybird={vehicle.hybird}
                    brandID={vehicle.brandID}
                    miniDownPayment={vehicle.miniDownPayment}
                    Tax={vehicle.Tax}
                    RateCareDiscount={vehicle.RateCareDiscount}
                    type={vehicle.type}
                    gifts={vehicle.countGifts}
                    hybridImage={vehicle.hybridImage}
                    colorName={vehicle?.shortDescriptionEn || null}
                    onClickShowSN={() => openProductGallery(vehicle?.productID, vehicle?.sn)}
                    btnShowSN={Boolean(cachByProduct[vehicle?.productID] || cachSNImages[vehicle?.sn])}
                  />
                ))}
              </div>
            ) : !isLoadingVehicles ? (
              <EmptyState message={trans("common:no_results")} />
            ) : null}
          </div>
        </div>
      </div>

      {offerVehicle?.length > 0 && <OfferSections title={trans("info:vehicle_offers")} offersList={offerVehicle} isVehicleOnline={true} />}

      <div className="container mt-20 mb-32">
        <div className="flex flex-wrap justify-center items-center gap-6">
          {Featured?.map((a) => (
            <InfoCircle key={a.id} icon={"data:image/image;base64," + a.icon} titleAr={a.titleAr} titleEn={a.titleEn} />
          ))}
        </div>
      </div>

      <div className="container mb-32">
        <Info />
      </div>

      <div style={{ opacity: isFullScreen ? 1 : 0, position: isFullScreen ? "relative" : "fixed", zIndex: isFullScreen ? 999999 : -1 }}>
        <ImageGallery
          ref={popRef}
          items={gallery}
          onScreenChange={(e) => setIsFullScreen(e)}
          isRTL={lang === "ar"}
          infinite={true}
          showNav={true}
          thumbnailPosition={"bottom"}
          showBullets={true}
        />
      </div>
    </div>
  );
}
